var headerHeight = $('#shopify-section-header').outerHeight();
var announcementHeight = $('#shopify-section-announcement-bar').outerHeight();

    if ($('.main-product-v2').length) {
        $('section.product').css('padding-top', `${ headerHeight + announcementHeight }px`);
            
        sliderThumbs = new Swiper(".thumbnail-slider", {
            slidesPerView: 7,
            spaceBetween: 10,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            watchSlidesProgress: true,
            breakpoints: {
                0: {
                    slidesPerView: 4.7,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 6.7,
                    spaceBetween: 10,
                },
                1024: {
                    slidesPerView: 7.7,
                    spaceBetween: 10,
                },
                1200: {
                    slidesPerView: 6.8,
                    spaceBetween: 10,
                },
                1400: {
                    slidesPerView: 8.7,
                    spaceBetween: 10,
                }
            },
        });
    }
$(document).ready(function() {

    if ($('.product-page-nav-header-section-v2').length) {
        $('.product-page-nav-header-section-v2 .btn.buy-now').click(function() {
            let $this = $(this);
            if ($this.data('clicked')) return; // Prevent multiple clicks

            $this.data('clicked', true); // Mark as clicked
            $('#more-payment-options-link').click();

            setTimeout(() => {
                $this.removeData('clicked'); // Allow clicking again after delay
            }, 1000); // Adjust delay as needed
        });
        
        $('.product-page-nav-header-section-v2').each(function () {

        // Get the top offset of the .product-header-section
        var productHeaderTop = $('.product-page-nav-header-section-v2').offset().top + 150;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .product-header-section sticky
            $('.main-nav-header-section').addClass('product-header-sticky');
            // Hide the header
            $('#shopify-section-header').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.main-nav-header-section').removeClass('product-header-sticky');
            // Show the header again
            $('#shopify-section-header').removeClass('header-hide');
        }
        

        });

        $(".section-scroll").each(function() {
            var sectionTop = $(this).offset().top - 100;
            var sectionBottom = sectionTop + $(this).outerHeight();
            var scrollPosition = $(window).scrollTop();
            
            var targetButton = $('.product-page-nav-header-section-v2 .nav-column.desktop .link-nav span[data-scroll="' + $(this).attr('data-scroll') + '"]');
        
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                targetButton.addClass("active");
                
                // Check if the section has a data-child-scroll attribute
                var childScroll = $(this).attr("data-child-scroll");
                if (childScroll) {
                    $('.product-page-nav-header-section-v2 .nav-column.desktop .link-nav span[data-scroll="' + childScroll + '"]').addClass("active");
                }
            } else {
                if (!$(this).attr("data-child-scroll")) {
                    targetButton.removeClass("active");
                }
            }
        });

        $('.product-page-nav-header-section-v2').each(function () {
            var $container = $(this); 
            $container.find('.nav-content .link-nav span').click(function(){
                console.log('here')
                $('.mobile-nav-title-selector').text($(this).text());
                $('.nav-content .link-nav span').removeClass('active');
                $(this).addClass('active');

            
                var targetAttr = $(this).attr('data-scroll');
                var $targetSection = $('.section-scroll[data-scroll="' + targetAttr + '"]').offset().top - 50;
                $("html, body").animate({
                    scrollTop: $targetSection
                }, 1);
            });
        
            $container.find('.custom-select-nav').click(function(){
                $(this).toggleClass('active');
            });
        });

        nav_header_scroll_v2();
    }   

    if ($('.vertical-stacked-slider').length) {
        const cards = document.querySelectorAll('.card-item');
        const section = document.querySelector('.vertical-stacked-slider');

        const activeState = { y: "2%", w: "100%" };

        function updateCardsOnScroll() {
            const scrollY = window.scrollY;
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            const startOffset = 500;
            let progress = (scrollY - sectionTop - startOffset + window.innerHeight) / sectionHeight;
            progress = Math.max(0, Math.min(1, progress));

            const totalCards = cards.length;
            const activeIndex = Math.min(Math.floor(progress * totalCards), totalCards - 1);

            cards.forEach((card, i) => {
                if (i < activeIndex) {
                    // distance from active card
                    const distance = activeIndex - i;
                    const stepY = 2; // % vertical shift
                    const stepW = 5; // % width decrease

                    const y = -stepY * distance + "%";
                    const w = 100 - stepW * distance + "%";

                    card.style.transform = `translateY(${y})`;
                    card.style.width = w;

                    // Brightness logic:
                    // Immediate previous (distance=1) stays full bright
                    if (distance === 1) {
                        card.style.filter = "brightness(1)";
                    } else {
                        // older cards fade gradually
                        const brightness = Math.max(0.5, 1 - distance * 0.2);
                        card.style.filter = `brightness(${brightness})`;
                    }

                } else if (i === activeIndex) {
                    // active card
                    card.style.transform = `translateY(${activeState.y})`;
                    card.style.width = activeState.w;
                    card.style.filter = "brightness(1)";
                } else {
                    // cards not yet active
                    card.style.transform = `translateY(120%)`;
                    card.style.width = "100%";
                    card.style.filter = "brightness(1)";
                }
            });
        }

        window.addEventListener('scroll', updateCardsOnScroll);
        window.addEventListener('resize', updateCardsOnScroll);
        updateCardsOnScroll();
    };

    if ($('.custom-sections').length) {
        $('.custom-sections').each(function () {
            const $custom = $(this); 
            const sectionId = $custom.data('section-id'); // unique id
            const $container = $custom.find('.section-container');
            const $sections = $custom.find('.item-sections');

            let segments = [];
            let totalScrollHeight = 0;
            let currentIndex = 0;
            let isSliding = false;

            $sections.each(function () {
                const contentVH = parseFloat($(this).data('scroll-length')) || 100;
                const contentPX = (contentVH / 100) * window.innerHeight;

                $(this).css('height', `${contentVH}vh`);

                segments.push({
                    start: totalScrollHeight,
                    hold: contentPX
                });

                totalScrollHeight += contentPX;
            });

            $custom.css('height', totalScrollHeight + 'px');

            $(window).on('scroll.section' + sectionId, function () {
                handleSlide();
                handleAnimations();
            });

            function handleSlide() {
                if (isSliding) return;

                const scrollY = scrolledPixels($custom);
                const seg = segments[currentIndex];
                const segEnd = seg.start + seg.hold;

                function slideTo(nextIndex) {
                    isSliding = true;

                    const $nextSection = $sections.eq(nextIndex);
                    const $floating = $nextSection.find('.floating-elements');
                    if ($floating.length) {
                        $floating.addClass('active');
                    }

                    $container.css('transform', `translateX(-${nextIndex * window.innerWidth}px)`);

                    setTimeout(() => {
                        currentIndex = nextIndex;
                        isSliding = false;

                        $sections.removeClass('active-item');
                        $sections.eq(currentIndex).addClass('active-item');
                    }, 700);
                }

                if (scrollY >= segEnd && currentIndex < $sections.length - 1) {
                    slideTo(currentIndex + 1);
                } else if (scrollY < seg.start && currentIndex > 0) {
                    slideTo(currentIndex - 1);
                }
            }

            let section4WasActiveItem = false; // track if section-4 was active last time

            function handleAnimations() {
                const scrollY = scrolledPixels($custom);

                $sections.each(function (i) {
                    const $section = $(this);
                    const seg = segments[i];
                    const triggerPoint = seg.start + seg.hold * 0.25;

                    if (scrollY >= triggerPoint) {
                        if ($section.hasClass('section-4')) {
                            const isActiveItem = $section.hasClass('active-item');

                            if (isActiveItem && !section4WasActiveItem) {
                                // SECTION-4 JUST BECAME ACTIVE → reset video ONCE
                                section4WasActiveItem = true;

                                $section.removeClass('video-mid video-done');

                                const $bgVideo = $section.find('.background-video').get(0);
                                if ($bgVideo) {
                                    $bgVideo.currentTime = 0;
                                    $bgVideo.play().catch(err => {
                                        console.log("Background video autoplay blocked:", err);
                                    });

                                    let reachedMid = false;
                                    let reachedDone = false;

                                    const onTimeUpdate = function () {
                                        if (!reachedMid && $bgVideo.currentTime >= 4) {
                                            $section.addClass('video-mid');
                                            reachedMid = true;
                                        }

                                        if (!reachedDone && $bgVideo.currentTime >= 6) {
                                            $section.addClass('video-done');
                                            reachedDone = true;
                                            $bgVideo.removeEventListener('timeupdate', onTimeUpdate);
                                            setTimeout(() => {
                                                $section.addClass('active');
                                            }, 300);    
                                        }
                                    };

                                    $bgVideo.addEventListener('timeupdate', onTimeUpdate);
                                }
                            } else if (!isActiveItem) {
                                // We left section-4 → allow reset next time it becomes active
                                section4WasActiveItem = false;
                            }

                        } else {
                            // Normal sections only animate once
                            if (!$section.data('animated')) {
                                $section.data('animated', true);
                                $section.addClass('active');

                                const $videos = $section.find('video');
                                $videos.each(function () {
                                    this.currentTime = 0;
                                    this.play().catch(err => {
                                        console.log("Video autoplay blocked:", err);
                                    });
                                });
                            }
                        }
                    }
                });
            }

            function scrolledPixels($el) {
                return $(window).scrollTop() - $el.offset().top;
            }

            $sections.removeClass('active-item');
            $sections.eq(0).addClass('active-item');
        });

    }


    if ($('.main-product-v2').length) {

        sliderImages = new Swiper(".main-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            mousewheel: false,
            pagination: {
                el: ".main-slider-pagination",
                clickable: true
            },
            navigation: {
                nextEl: ".main-slider-next",
                prevEl: ".main-slider-prev"
            },
            grabCursor: true,
            thumbs: {
                swiper: sliderThumbs
            },
            breakpoints: {
                0: { autoHeight: true },
                768: { autoHeight: false }
            },
            on: {
                slideChange: function () {
                    // stop all videos
                    document.querySelectorAll(".main-slider video").forEach(video => {
                        video.pause();
                        video.currentTime = 0;
                    });

                    // play video in active slide
                    const activeSlideVideo = this.slides[this.activeIndex].querySelector('video');
                    if (activeSlideVideo) {
                        activeSlideVideo.play();
                    }
                },
                init: function () {
                    // autoplay video on the first slide when Swiper initializes
                    const firstVideo = this.slides[this.activeIndex].querySelector('video');
                    if (firstVideo) {
                        firstVideo.play();
                    }
                }
            }
        });




        gallerySlider = new Swiper(".gallery-slider", {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 20,
            speed: 1000,
            navigation: {
                nextEl: ".slider-next",
                prevEl: ".slider-prev"
            },
            grabCursor: true,
            watchSlidesProgress: true,
        });

        gallerySlider.controller.control = sliderImages;
        sliderImages.controller.control = gallerySlider;


        
        $(".product-description .btn-show").on("click", function(){
            console.log('here')
                var $desc = $(".product-description .inner-description");
                $desc.toggleClass("expanded");

                if ($desc.hasClass("expanded")) {
                    $(this).text("Show Less");
                } else {
                    $(this).text("Learn More");
                }
        });

        
        if ($('.discount-banner-countdown').length) {
            var countdownDate = $(".discount-banner-countdown").data("date"); 
            var product_page_countdown = new Date(countdownDate).getTime();
            
            var countdownInterval = setInterval(function() {
            var now = new Date().getTime();

            var timeDifference = product_page_countdown - now;

            // Calculate days, hours, minutes, and seconds
            var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
            var hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

            // Add leading zeros if the value is less than 10
            days = days < 10 ? '0' + days : days;
            hours = hours < 10 ? '0' + hours : hours;
            minutes = minutes < 10 ? '0' + minutes : minutes;
            seconds = seconds < 10 ? '0' + seconds : seconds;

            // Display the result in the respective HTML elements
            $('.day-data').text(days);
            $('.hour-data').text(hours);
            $('.minute-data').text(minutes);
            $('.second-data').text(seconds);

            // If the countdown is finished, clear the interval
            if (timeDifference < 0) {
                clearInterval(countdownInterval);
                $('.day-data, .hour-data, .minute-data, .second-data').text('00');
                $('.discount-banner-countdown').addClass('hidden-important');
            }
            }, 1000);
        }

                
        $('.discount-banner-content').each(function() {
            var $banner = $(this);

            $banner.find('.copy-code-btn').click(function() {
                var $btn = $(this);
                var discountCode = $banner.find('.discount-code-input').text(); // or .val() if it's an input

                navigator.clipboard.writeText(discountCode).then(function() {
                    // Change button text to "Copied!"
                    $btn.find('span').text('Copied!');

                    // Revert button text after 2 seconds
                    setTimeout(function() {
                        $btn.find('span').text('Copy');
                    }, 2000);
                }, function(err) {
                    console.error('Failed to copy discount code:', err);
                });
            });
        });



    }
    
    section_scroll_animation();
});

function nav_header_scroll_v2(){
    console.log('here')
  if ($('.product-page-nav-header-section-v2').length) {
      $('.product-page-nav-header-section-v2').each(function () {

        // Get the top offset of the .product-header-section
        var productHeaderTop = $('.product-page-nav-header-section-v2').offset().top + 150;
        var scrollPosition = $(window).scrollTop();

        // Check the scroll position
        if ($(window).scrollTop() >= productHeaderTop) {
            // Make the .product-header-section sticky
            $('.main-nav-header-section').addClass('product-header-sticky');
            // Hide the header
            $('#shopify-section-header').addClass('header-hide');
        } else {
            // Remove the sticky class when scrolling above the section
            $('.main-nav-header-section').removeClass('product-header-sticky');
            // Show the header again
            $('#shopify-section-header').removeClass('header-hide');
        }
        

      });
    
      $(".section-scroll").each(function() {
          var sectionTop = $(this).offset().top - 100;
          var sectionBottom = sectionTop + $(this).outerHeight();
          var scrollPosition = $(window).scrollTop();
          
          var targetButton = $('.product-page-nav-header-section-v2 .nav-column.desktop .link-nav span[data-scroll="' + $(this).attr('data-scroll') + '"]');
      
          if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
              targetButton.addClass("active");
              
              // Check if the section has a data-child-scroll attribute
              var childScroll = $(this).attr("data-child-scroll");
              if (childScroll) {
                  $('.product-page-nav-header-section-v2 .nav-column.desktop .link-nav span[data-scroll="' + childScroll + '"]').addClass("active");
              }
          } else {
              if (!$(this).attr("data-child-scroll")) {
                  targetButton.removeClass("active");
              }
          }
      });


  }
}

$(window).on('scroll', function() {
    section_scroll_animation();
    if ($('.product-page-nav-header-section-v2').length) {
        nav_header_scroll_v2();
    }
  
});

function section_scroll_animation() {
    $('.section-animation').each(function() {
            let el = $(this);
      
        if (visiblePercent(el) > 30){
            $(this).addClass('animate');
        }
      
    });
}

$(document).on('submit', '.atc-form', function (event) {
    event.preventDefault();
    let form = $(this);
    let formData = form.serialize();

    form.find('.btn-atc span').css('visibility', 'hidden');
    form.find('.btn-atc .atc-overlay').css('display', 'flex');

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
            console.log('added');
            form.find('.btn-atc span').css('visibility', 'visible');
            form.find('.btn-atc .atc-overlay').css('display', 'none');

            
            // 🔹 Option 1: trigger cart:refresh (refreshes cart drawer)
            document.dispatchEvent(new CustomEvent('cart:refresh', {
                detail: { open: true } // open:true will auto-show the drawer
            }));

            // 🔹 Option 2: publish via theme.pubsub (updates cart items)
            if (theme && theme.pubsub) {
                fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
                    source: 'ajax-add',
                    cart: cart
                    });
                });
            }
        },
        error: function (xhr, status, error) {
            console.error('Error adding product to cart:', error);
            form.find('.btn-atc span').css('visibility', 'visible');
            form.find('.btn-atc .atc-overlay').css('display', 'none');
        }
    });
});


// POPUP MODAL
$('.popup-modal').each(function () {
    var $container = $(this);
    $container.find('.popup-close').click(function(){
        $container.removeClass('open');
        $('body').removeClass('no-scroll');
    });
    $container.find('.popup-overlay').click(function(){
        $container.removeClass('open');
        $('body').removeClass('no-scroll');
    });

});